<main class="main">
  <nav class="sidebarLeft sidebar">
    <div class="sidebar-sticky">
      <div class="proj-sidebar-info">
        <span *ngIf="!isNSI"  class="icon-left text-secondary"></span>
        <a *ngIf="!isNSI" [routerLink]="[destinoRouter]">   {{'WorkflowCreate.Back' | translate}}</a>
        <div class="mt-3">
          <label for="workflowCode">
            {{ workflowDefinition.workflowCodeCGA }}
          </label>
          <h1 class="text-secondary">
            {{ workflowDefinition.title }}
          </h1>
          <p class="text-secondary">
          </p>
          <a tabindex="0" [routerLink]="" aria-label="Link com Instruções" (click)="getInstructions()" class="card-link" referrerpolicy="origin">{{'WorkflowSearch.Instructions' | translate}}</a>
        </div>
      </div>
      <div class="proj-sidebar-navegation" *ngIf="isLoadedInstance && stepCode!='DeceasedIdentification'   ">
        <button aria-label="Salvar" type="button" class="btn btn-primary" (click)="onSaveWorkflowData($event)" id="wf-save-button"
                name="wf-save-button" visualActionUnauthorized action="{{VisualActions.hide}}" permission="WorkflowEditPage.SaveData"
                *ngIf="!isAtendimento && !faseParaValidacaoLegal && !isRLIndeferida" tabindex="0">
          <span class="icon-save"></span><span>{{'Workflow.Save' | translate}}</span>
        </button>
        <button *ngIf="!(isWorkflowOnSubscriber || faseParaValidacaoLegal)  && !isRLIndeferida " aria-label="Apagar" type="button" class="btn btn-outline-primary mt-3"
                (click)="onDeleteWorkflowData($event)" id="wf-delete-button"
                name="wf-delete-button" visualActionUnauthorized action="{{VisualActions.hide}}" permission="WorkflowEditPage.DeleteData" tabindex="0">
          <span class="icon-trash"></span><span>{{'Workflow.Terminate' | translate}}</span>
        </button>
      </div>



    </div>
  </nav>
  <div class="wrapper">

    <div class="container-fluid" *ngIf="workflowInstance!==null && workflowInstance!==undefined && isLoading==false">
      <form name="cgaWorkflowForm" #cgaWorkflowForm="ngForm">
        <fieldset visualActionUnauthorized action="{{VisualActions.disable}}" permission="WorkflowEditPage.EditData">
          <fieldset >
            <alert></alert>
            <!--<div class="form-group text-secondary ft-sz-12">
    <label for="Campos obrigatórios" style="color:#DB3347"><span class="mandatory"></span>{{'Workflow.Mandatory' | translate}}</label>
  </div>-->
            <!-- PRESTAÇÕES POR MORTE-->
            <fieldset [disabled]="estadoPendente">
              <div [ngSwitch]="stepCode" class=" mt-4 requestType">

                <!-- STEP 1 DeceasedIdentification-->
                <deceased-identification-pre-stage *ngSwitchCase="'DeceasedIdentification'"
                                                   [(model)]="credentials" [isAtendimento]="isAtendimento">
                </deceased-identification-pre-stage>

                <ng-context>
                  <!-- STEP 2 SenderQualification-->
                  <div *ngSwitchCase="'SenderQualification'"
                       class="mb-8">
                    <sender-qualification-pre-stage [(model)]="workflowInstance.StepSender.SenderQualification"
                                                    [isLegalRepresentationEnabled]="isLegalRepresentationEnabled">
                    </sender-qualification-pre-stage>
                    <br />
                    <representados-list-pre-stage *ngIf="workflowInstance.StepSender.SenderQualification.isLegalRepresentative"
                                                  [dropdowns]="dropdowns"
                                                  [isSenderBeneficiary]="workflowInstance.StepSender.SenderQualification.isBeneficiary"
                                         
                                                  [nifDeceased]="nifDeceased"
                                                  [nifRepresentanteLegal]="workflowInstance.StepSender.SenderIdentification.NIF"
                                                  (documentListChanged)="onDocumentListChanged($event)"
                                                  [estadoPendente]="estadoPendente"
                                                  [documentsList]="workflowInstance.StepDocumentsPM.DocumentationPM?.documentsList"
                                                  [isLegalRepresentative]="workflowInstance.StepSender.SenderQualification.isLegalRepresentative"
                                                  [isBeneficiary]="workflowInstance.StepSender.SenderQualification.isBeneficiary"
                                                  [(model)]="workflowInstance.StepBeneficiary.Beneficiary"
                                                  [stateCode]="stateCode"
                                                  [statePhase]="statePhase"
                                                  (isOnEdit)="onIsEdit($event)">

                    </representados-list-pre-stage>

                  </div>
                  <!-- STEP 3 SenderIdentification-->
                  <div *ngSwitchCase="'SenderIdentification'"
                       class="mb-8">
                    @if(isServiceOrFunerary !== null && isServiceOrFunerary !== undefined){

                      @if(isServiceOrFunerary === false){
                      <sender-identification-pre-stage *ngIf="workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString()=='false'"
                                                       [(model)]="workflowInstance.StepSender.SenderIdentification"
                                                       [dropdowns]="dropdowns"
                                                       [qualification]="workflowInstance.StepSender.SenderQualification">
                      </sender-identification-pre-stage>
                      }

                      @if(isServiceOrFunerary === true){
                      <service-identification-pre-stage *ngIf="workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString()=='true'"
                                                        [(model)]="workflowInstance.StepSender.SenderIdentification">

                      </service-identification-pre-stage>
                      }
                      <br />

                      <sender-contacts-pre-stage [isCertified]="workflowInstance.StepSender.SenderIdentification.isCertified"
                                                 [(model)]="workflowInstance.StepSender.SenderContacts"
                                                 [qualification]="workflowInstance.StepSender.SenderQualification">

                      </sender-contacts-pre-stage>
                    }

                  </div>

                  <!--STEP 4 Beneficiarios -->
                  <beneficiary-list-pre-stage *ngSwitchCase="'Beneficiaries'" (isOnEdit)="onIsEdit($event)"
                                              (listChanged)="OnBeneficiaryListChanged($event)"
                                              [qualificationIsBeneficiary]="workflowInstance.StepSender.SenderQualification.isBeneficiary?.toString()=='true'"
                                              [qualificationIsLegalRepresentative]="workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString()=='true'"
                                              [isFuneraryOrService]="workflowInstance.StepSender.SenderQualification.isServiceOrFunerary?.toString()=='true'"
                                             
                                              [senderNIF]="this.workflowInstance.StepSender.SenderIdentification.NIF"
                                              [hasLegalRepresentation]="workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString()=='true'"
                                              [workflowInstanceId]="workflowInstanceId"
                                              [deceasedSubscriberNumber]="workflowInstance.StepDeceased.DeceasedIdentification.subscriberNumber"
                                              [workflowCode]="workflowCode"
                                              [nifDeceased]="nifDeceased"
                                              [estadoPendente]="estadoPendente"
                                              [dropdowns]="dropdowns"
                                              [deathDate]="workflowInstance.StepDeceased.DeceasedIdentification.deathDate"
                                              [(model)]="workflowInstance.StepBeneficiary.Beneficiary"></beneficiary-list-pre-stage>

                  <!--STEP 5 Documents -->
                  <documentation-pm-pre-stage *ngSwitchCase="'Documents'"
                                              [instanceRole]="instanceRole"
                                              [beneficiaryList]="workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList"
                                              [senderIdentification]="workflowInstance.StepSender.SenderIdentification"
                                              [deceasedIdentification]="workflowInstance.StepDeceased.DeceasedIdentification"
                                              [dropdowns]="dropdowns"
                                              [workflowInstanceId]="workflowInstanceId"
                                              [stateCode]="stateCode"
                                              [statePhase]="statePhase"
                                              [(model)]="workflowInstance.StepDocumentsPM.DocumentationPM"></documentation-pm-pre-stage>

                  <!--STEP 6 SubmitPreStage-->
                  <submit-pre-stage-pm *ngSwitchCase="'SubmitPreStage'"></submit-pre-stage-pm>
                  <do-nothing *ngSwitchCase="'InValidation'"
                              [isRLIndeferida]="isRLIndeferida"></do-nothing>
                </ng-context>

              </div>

            </fieldset>





              <!-- FOOTER BUTTONS -->
              <div *ngIf="currentStep==1 ">
                <!-- caso -1 para pagina em branco para loader-->
                <div class="row mt-4 mb-50">
                  <div class="col-sm-6 text-start">
                    <div *ngIf="isButtonBeforeVisible()"
                         class="btn-group" role="group" aria-label="Recuar no pedido">
                      <button appDebounceClick type="button"
                              [disabled]="(workflowTemplate==null || workflowTemplate==undefined) || !allowMajorActions || stepCode=='SenderQualification'"
                              class="btn btn-primary" aria-label="Recuar no pedido"
                              id="wf-back-button" name="wf-next-button" (debounceClick)="onStepBefore()" tabindex="0">
                        <span class="icon-left"></span>
                        <span>{{ 'WorkflowCreate.Before' | translate}}</span>

                      </button>
                    </div>
                  </div>
                  <div class="col-sm-6 text-end">
                    <div class="btn-group" role="group" aria-label="Avançar no pedido">
                      <button appDebounceClick type="button"
                              [disabled]="!isValidForm(cgaWorkflowForm) || isButtonNextDisable() || (estadoPendente && stepCode== 'InValidation') || (stepCode== 'SubmitPreStage' && isAtendimento)"
                              class="btn btn-primary" aria-label="Avançar no pedido"
                              id="wf-next-button" name="wf-next-button" (debounceClick)="onStepNext()" tabindex="0">
                        <span *ngIf="currentStep == 2" class="icon-send"></span>
                        @if(stepCode!='StepSender' && stepCode!='SubmitPreStage'){
                        <span>{{ 'WorkflowCreate.Next' | translate}}</span>
                        } @else {
                        <span>{{ 'WorkflowCreate.Submit' | translate}}</span>
                        }
                        <span *ngIf="currentStep == 1" class="icon-right"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </fieldset>
          </fieldset>
       <!-- <span>cgaWorkflowForm.valid:{{isValidForm(cgaWorkflowForm)}} || isButtonNextDisable(): {{isButtonNextDisable()}}</span>-->
      </form>
    </div>
  </div>

</main>
<!-- FORM FAKE -->
<form id="formGetFile" #cgaGetFileForm="ngForm" name="formGetFile" method="POST" target="_blank" referrerpolicy="origin">
  <input #cgaGetFileFormInput type="hidden" name="h_queryParams" id="h_queryParams" value="">
  <input type="hidden" name="h_transfDir" id="h_transfDir" value="Download">
  <input type="hidden" name="h_operId" id="h_operId" value="PubFich">
</form>
